import { slugify } from 'utils/misc';
import React from 'react';

export default function ScoreCardView({ matchData }) {
   let matchResult = "";

    const getMatchResult=()=>{

        switch (matchData.Winner) {
            case "1": {
                matchResult = matchData.Team2.TeamName + " won by " + eval(10 - parseInt(matchData.Team2.Wicket)) + " wickets";
                break;
            }
            case "2":{
                matchResult = matchData.Team1.TeamName + " won by "
                + eval(parseInt(matchData.Team1.Score) - parseInt(matchData.Team2.Score)) + " runs";
                break;
            }
            case "3":{
                matchResult = "Match Tied";
                break;
            }
        }
        return matchResult;
    }

    return (
        <div>
            <p className='m-0 p-0 small'>({matchData.TourName}) {matchData.RoundName} on {matchData.MatchDate} at {matchData.PlayName}</p>
            <p className='m-0 p-0 fw-bold'>
                <a href={"/match/" + slugify(matchData.Team1.TeamName + "-vs-" + matchData.Team2.TeamName) + "-" + matchData.MatchId}>
                    {matchData.Team1.TeamName}

                    <span> {matchData.Team1.Score}/{matchData.Team1.Wicket}</span>

                    <span> ({parseFloat(matchData.Team1.Over).toFixed(1)})</span>
                    {' '}
                    vs
                    {' '}
                    {matchData.Team2.TeamName}
                    <span className='"+team2class+"'> {matchData.Team2.Score}/{matchData.Team2.Wicket}</span>
                    <span className='overs'> ({parseFloat(matchData.Team2.Over).toFixed(1)})</span>
                </a>
            </p>
            <div className='small'>{getMatchResult()}</div>
            Man of the Match: <a href={'/players/' + slugify(matchData.MOM.Name) + "-" + matchData?.MOM?.PlayerId}>{matchData.MOM.Name}</a>
        </div>
    )
}